/**
 * LEVERADE Generic collection
 *
 * When the project started, we didn't have the concept of Series and Collections. Instead, all trophies and cards
 * belonged to a common implicit collection (i.e. they all belonged to the same trophy or card-specific smart contract).
 *
 * As part to the implementation of Series and Collections, previous products have been attached to a generic series and
 * collection.
 */
export const LEVERADE_COLLECTION_ID = '1c97a3ca-fa0b-44c1-b8d8-2d875afa059a'

/**
 * RFEN Queen's Cup collection
 *
 * When the project started, we didn't have the concept of Series and Collections. Our first use case was the Waterpolo
 * Queen's Cup, that we minted in the Polygon network.
 *
 * As part to the implementation of Series and Collections, these trophies have been attached to a specific series and
 * collection.
 */
export const QUEENSCUP_COLLECTION_ID = '0dade6f5-86e9-4a35-8698-dafae56d8053'

export interface CollectionInterface {
  id: string
  contractAddress: string
  contractChain: string
  contractAbi?: string
  seriesId: string
  type: string
}

export class Collection {
  // eslint-disable-next-line no-useless-constructor
  constructor (
    public readonly id: string,
    public readonly contractAddress: string,
    public readonly contractChain: string,
    public readonly contractAbi: string,
    public readonly seriesId: string,
    public readonly type: string
  ) {}

  public isSeriesCollection (): boolean {
    return this.id !== LEVERADE_COLLECTION_ID && this.id !== QUEENSCUP_COLLECTION_ID
  }

  public toJSON (): CollectionInterface {
    return {
      id: this.id,
      contractAddress: this.contractAddress,
      contractChain: this.contractChain,
      seriesId: this.seriesId,
      type: this.type,
    }
  }
}
